import './helpers';

import 'font-awesome/css/font-awesome.css';

import 'jquery';
import 'jquery-ui-dist/jquery-ui.js';
// NOTE: Умышленно не подключаем стили, т.к. в старой версии они тоже не подключались.
// Если их подключить, то из-за `touch-action: none;` на сортируемом списке в разделе
// прайс листа - страница не прокручивается. Чтобы не мудрить и сделать как было,
// решено так-же не включать этот стиль :D
// import 'jquery-ui-dist/jquery-ui.css';

import '@legacy/styles/bootstrap-custom.less';
import 'bootstrap';

import '@legacy/styles/common.css';
import '@legacy/styles/car-number.css';
import '@legacy/styles/main.scss';

import 'moment';
import 'moment/locale/ru';
import 'moment-timezone';

import 'angular/angular.js';
import 'angular-resource/angular-resource.js';
import 'angular-route/angular-route.js';
import 'angular-animate/angular-animate.js';
import 'angular-ui-router/release/angular-ui-router.js';
import 'angular-ui-bootstrap/dist/ui-bootstrap-tpls.js';
import 'angular-i18n/angular-locale_ru-ru.js';
import 'angular-ui-sortable/src/sortable.js';

import 'ng-tags-input/build/ng-tags-input.min.js';
import 'ng-tags-input/build/ng-tags-input.min.css';
import '@legacy/styles/ng-tags-input.scss';

// Было еще такое, но оно нигде не использовалось:
// see: https://github.com/wouterbulten/kalmanjs

// import 'd3'; // Autoexport global
// NOTE: Пришлось вернуть локально-подключаемую библиотеку, в ней есть кусок подпертый костылем (line: ~6697). 
// Так делать точно нельзя было, но и коматься в этом тоже не хочется.
// В ближайшее время дашборд будет выкинут и библиотка полностью удалена 
import '@/legacy/lib/d3/d3.js';

import * as Base64 from 'js-base64';

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

import 'videojs-errors';
import 'videojs-errors/dist/videojs-errors.css';

// NOTE: Вообще не пойми, что за динозавр!
import '@legacy/lib/sk3/sk3.js';
import '@legacy/lib/sk3/styles.css';

import '@legacy/lib/fullCalendar/style.css';
import '@legacy/lib/fullCalendar/fullCalendar.js';
import '@legacy/lib/fullCalendar/ru.global.min.js';

// Export global!
Object.assign(window, {
  videojs,
  Base64,
});

//--- Application -------------------------------------------------------------
import '@legacy/app/app.js';

import '@legacy/app/module/utils.js'
import '@legacy/app/service/init.js'
import '@legacy/app/service/recon.js'
import '@legacy/app/service/suspiciousEvents.js'
import '@legacy/app/service/authService.js'
import '@legacy/app/service/popups.js'
import '@legacy/app/service/billingService.js'
import '@legacy/app/service/consumers.service.js'
import '@legacy/app/service/visits.service.js'
import '@legacy/app/service/dataService.js'
import '@legacy/app/service/resources.js'
import '@legacy/app/service/form-helper.js'
import '@legacy/app/service/interceptors/error.interceptor.js'
import '@legacy/app/controller/index.js'
import '@legacy/app/controller/login.js'
import '@legacy/app/controller/popup/errorMessagePopup.controller.js'
import '@legacy/app/controller/popup/PersonalDataPopup.controller.js'
import '@legacy/app/controller/analytics.js'
import '@legacy/app/controller/statistics.js'
import '@legacy/app/controller/stream-cameras.js'
import '@legacy/app/controller/stream-archive.js'
import '@legacy/app/controller/settings-groups.js'
import '@legacy/app/controller/settings-discount.js'
import '@legacy/app/controller/settings-messages.js'
import '@legacy/app/controller/settings-shifts.js'
import '@legacy/app/controller/settings-cameras.js'
import '@legacy/app/controller/settings-password.js'
import '@legacy/app/controller/settings-cabinet.js'
import '@legacy/app/controller/settings-sms.js'
import '@legacy/app/controller/settings-events.js'
import '@legacy/app/controller/settings-booking.js'
import '@legacy/app/controller/settings-boxes.js'
import '@legacy/app/controller/settings-atol.js'
import '@legacy/app/controller/yandex-fuel.js'
import '@legacy/app/controller/doer-subscription.js'
import '@legacy/app/controller/kkt-settings.js'
import '@legacy/app/controller/settings-evotor.js'
import '@legacy/app/controller/staff.js'
import '@legacy/app/controller/visit.js'
import '@legacy/app/controller/alarms.js'
import '@legacy/app/controller/billing.js'
import '@legacy/app/controller/error.js'
import '@legacy/app/controller/feedback.js'
import '@legacy/app/controller/consumers-sms.js'
import '@legacy/app/controller/consumers-telegram.js'
import '@legacy/app/controller/consumers-distributions-sms-list.js'
import '@legacy/app/controller/consumers-distributions-telegram-list.js'
import '@legacy/app/components/consumers/popup/consumers-discount-campaigns.component.js'
import '@legacy/app/components/consumers/popup/consumers-new-car.component.js'
import '@legacy/app/components/consumers/client-import-export-widget.component.js'
import '@legacy/app/components/cars/car-group-import-export-widget.component.js'
import '@legacy/app/controller/work-orders.js'
import '@legacy/app/controller/sales-funnel.js'
import '@legacy/app/controller/planner.js'
import '@legacy/app/components/ui-components/tags.component.js'
import '@legacy/app/components/indicator-status.component.js'
import '@legacy/app/components/file-import.service.js'
import '@legacy/app/components/visit/payment-value.component.js'
import '@legacy/app/components/autocomplete/autocomplete.component.js'
import '@legacy/app/components/counterparty/counterparty-select.component.js'
import '@legacy/app/components/erp/organization/organization-detail.component.js'
import '@legacy/app/components/erp/organization/organization-detail-common.component.js'
import '@legacy/app/components/erp/organization/organization-bank-details.component.js'
import '@legacy/app/components/erp/organization/organization-responsible-persons.component.js'
import '@legacy/app/components/erp/organization/organization-documents.component.js'
import '@legacy/app/components/erp/employee/employee-reward.component.js'
import '@legacy/app/components/compensation/employee-salary.component.js'
import '@legacy/app/components/compensation/popup/salary.component.js'
import '@legacy/app/components/wms/wms-entrypoint.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature.service.js'
import '@legacy/app/components/wms/nomenclature/nomenclature.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-search.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-select.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-multiselect-tags.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-detail.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-detail-common.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-detail-warehouse.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-detail-flowsheet.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-category.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-category-breadcrumbs.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-category-tree.component.js'
import '@legacy/app/components/wms/nomenclature/nomenclature-category-multiselect-tags.component.js'
import '@legacy/app/components/wms/warehouse/warehouse-entrypoint.component.js'
import '@legacy/app/components/wms/warehouse/warehouse-nomenclature.component.js'
import '@legacy/app/components/wms/warehouse/warehouse-list.component.js'
import '@legacy/app/components/wms/warehouse/warehouse-select.component.js'
import '@legacy/app/components/wms/warehouse/warehouse.service.js'
import '@legacy/app/components/wms/document/document-list.component.js'
import '@legacy/app/components/wms/document/document-detail.component.js'
import '@legacy/app/components/wms/document/document-act-movement.component.js'
import '@legacy/app/components/wms/document/document-act-writeoff.component.js'
import '@legacy/app/components/wms/document/document-consignment-incoming.component.js'
import '@legacy/app/components/wms/analytic/analytic.component.js'
import '@legacy/app/components/wms/analytic/analytic.station.component.js'
import '@legacy/app/components/wms/car_classes/car_classes.component.js'
import '@legacy/app/components/wms/car_classes/car-class-search.component.js'
import '@legacy/app/components/dms/document-list.component.js'
import '@legacy/app/components/dms/document.service.js'
import '@legacy/app/components/dms/document-type.filter.js'
import '@legacy/app/components/dms/document-number.filter.js'
import '@legacy/app/components/pricelist/service-select.component.js'
import '@legacy/app/components/pricelist/pricelist.component.js'
import '@legacy/app/components/pricelist/pricelist-station.component.js'
import '@legacy/app/components/pricelist/pricelist-price-category.component.js'
import '@legacy/app/components/pricelist/price-export.service.js'
import '@legacy/app/components/pricelist/price-export-widget.component.js'
import '@legacy/app/components/pricelist/price-import-export-widget.component.js'
import '@legacy/app/components/pricelist/price-policy/price-policy.service.js'
import '@legacy/app/components/pricelist/price-policy/price-policy-widget.component.js'
import '@legacy/app/components/pricelist/price-policy/price-policy-detail.component.js'
import '@legacy/app/components/discount/discount.service.js'
import '@legacy/app/components/discount/discount-applicability.component.js'
import '@legacy/app/components/discount/discount-validity.component.js'
import '@legacy/app/components/analytic-datepicker/analytic-datepicker.component.js'
import '@legacy/app/components/work-orders/work-orders-form.component.js'
import '@legacy/app/components/work-orders/work-orders-form-car.component.js'
import '@legacy/app/components/work-orders/work-orders-form-carvisit.component.js'
import '@legacy/app/components/work-orders/work-orders-form-carvisit-service.component.js'
import '@legacy/app/components/work-orders/work-orders-form-carvisit-product.component.js'
import '@legacy/app/components/work-orders/work-orders-form-carvisit-calendar.component.js'
import '@legacy/app/components/work-orders/work-orders-form-members.component.js'
import '@legacy/app/components/work-orders/work-orders-form-client.component.js'
import '@legacy/app/components/work-orders/work-orders-form-user.component.js'
import '@legacy/app/components/work-orders/work-orders-form-services.component.js'
import '@legacy/app/components/work-orders/work-orders-form-service.component.js'
import '@legacy/app/components/work-orders/work-orders-form-products.component.js'
import '@legacy/app/components/work-orders/work-orders-form-product.component.js'
import '@legacy/app/directive/cSalaryGraphUpdate.js'
import '@legacy/app/directive/cAlarmEntry.js'
import '@legacy/app/directive/cBackgroundImg.js'
import '@legacy/app/directive/cCarNumber.js'
import '@legacy/app/directive/cSetFocus.js'
import '@legacy/app/directive/input-nullable.js'
import '@legacy/app/directive/input-autofocus.js'
import '@legacy/app/directive/input-date.js'
import '@legacy/app/directive/customOnChange.js'
import '@legacy/app/filters/contains-in-array.filter.js'
import '@legacy/app/filters/duration.filter.js'
import '@legacy/app/filters/sonar-duration.filter.js'
import '@legacy/app/filters/phone-formatter.filter.js'
import '@legacy/app/filters/moment-unix-date.filter.js'
import '@legacy/app/filters/sonar-statuses.filter.js'
import '@legacy/app/filters/moment-date.filter.js'
import '@legacy/app/controller/popup/all.js'
import '@legacy/app/controller/popup/DownloadReportPopup.js'
import '@legacy/app/controller/popup/NewTypePopup.controller.js'
import '@legacy/app/controller/popup/EditTypePopup.controller.js'
import '@legacy/app/controller/popup/NewCarCategoryPopup.controller.js'
import '@legacy/app/controller/popup/AddPurchasePopup.controller.js'
import '@legacy/app/controller/popup/purchasesHistory.controller.js'
import '@legacy/app/controller/popup/DistributionSmsCreatePopup.controller.js'
import '@legacy/app/controller/popup/DistributionTelegramCreatePopup.controller.js'
import '@legacy/app/controller/popup/confirm-popup.controller.js'
import '@legacy/app/controller/popup/confirmation-popup.controller.js'
import '@legacy/app/controller/popup/prompt-popup.controller.js'
import '@legacy/app/controller/popup/alert-popup.controller.js'
import '@legacy/app/controller/popup/PriceListExportPoup.controller.js'
import '@legacy/app/controller/point-list.js'

import '@legacy/app/components/suppurt-popup/suppurt-popup.component';
import '@legacy/app/components/account-widget/account-widget.component';
import '@legacy/app/components/main-notice/main-notice.component';
